import React from "react";
import "../Navigation/css/NavBar.scss";
import {Black} from "../../theme/styles";
import ReactJson from "react-json-view";
import authenticate_put_request from "../../json/authenticate/authenticate-put-request.json";
import authenticate_put_response from "../../json/authenticate/authenticate-put-response.json";


export default function AuthenticatePUT() {

    return (
        <div style={{paddingLeft: "20px", paddingRight: "30px"}}>
            <p style={{fontSize: "24px", fontWeight: "400", color: Black}}>Authenticate PUT</p>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>Overview</p>

            <p style={{fontSize: "14px", fontWeight: "400", color: Black, marginLeft: "20px"}}>
                This API will create a new X-Enlil-AccessToken if given the X-Enlil-RefreshToken.
            </p>
            <br/>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>Parameters</p>
            <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                <li style={{marginTop: "20px"}}>Header Parameters
                    <li style={{marginTop: "20px", marginLeft: "20px"}}>X-Enlil-RefreshToken (Required String)</li>
                    <li style={{marginTop: "10px", marginLeft: "40px"}}>The X-Enlil-RefreshToken is obtained during the authentication process and never expires.</li>
                </li>
                <li style={{marginTop: "20px"}}>PUT Body
                    <p style={{fontFamily: "Courier New", fontSize: "12px"}}>
                        <ReactJson src={authenticate_put_request} collapseStringsAfterLength={75} collapsed={4}/>
                    </p>
                </li>
            </ul>
            <br/>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>Example</p>
            <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                A PUT execution will look as follows.
                <span style={{fontFamily: "Courier New", fontSize: "14px",}}><br/><br/>curl -d '&#123;"X-Enlil-RefreshToken":"&#60;key&#62;"&#125;' -X PUT "https://api.integrate.dev2.enlil.io/t3/v1/authenticate"</span><br/><br/>
                It will respond with a payload similar to the following.<br/><br/>
                <p style={{fontFamily: "Courier New", fontSize: "12px"}}>
                    <ReactJson src={authenticate_put_response} collapseStringsAfterLength={75} collapsed={4}/>
                </p>
                <br/>
            </ul>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>Error Codes</p>
            <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                <li style={{marginTop: "20px"}}>400 CC-4500-4E51 - Invalid payload:</li>
                <li style={{marginTop: "10px", marginLeft: "40px"}}>Description: Invalid payload. The user did not provide a PUT body.</li>
                <li style={{marginTop: "10px", marginLeft: "40px"}}>HTTP Code: 400</li>
            </ul>
            <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                <li style={{marginTop: "20px"}}>400 CC-895C-4107 - Missing payload field: RefreshToken</li>
                <li style={{marginTop: "10px", marginLeft: "40px"}}>Description: Missing payload field: RefreshToken. The user did not provide the X-Enlil-RefreshToken in the payload.</li>
                <li style={{marginTop: "10px", marginLeft: "40px"}}>HTTP Code: 400</li>
            </ul>
            <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                <li style={{marginTop: "20px"}}>400 CC-F235-458C - Invalid payload field: RefreshToken</li>
                <li style={{marginTop: "10px", marginLeft: "40px"}}>Description: Invalid payload field: RefreshToken. The provided X-Enlil-RefreshToken is not a valid token.</li>
                <li style={{marginTop: "10px", marginLeft: "40px"}}>HTTP Code: 400</li>
            </ul>
            <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                <li style={{marginTop: "20px"}}>400 CC-788C-4725 - Invalid payload field: RefreshToken</li>
                <li style={{marginTop: "10px", marginLeft: "40px"}}>Description: Invalid payload field: RefreshToken. The provided X-Enlil-RefreshToken has an incorrect scope attribute.</li>
                <li style={{marginTop: "10px", marginLeft: "40px"}}>HTTP Code: 400</li>
            </ul>
            <br/>
        </div>
    )
}